import toast, { Toaster, useToasterStore } from "react-hot-toast"
import { useEffect } from "react"
import { useAtomValue } from "jotai"
import { isShowingClustersAtom } from "@/store/importing/culling-state"
import { filmstripExpandedAtom, isPhotoFullscreenAtom } from "@/store/ui-views-state"
import { photosViewAtom } from "@/store/photo/photos-view-state"

export const Toasts = () => {
	const { toasts } = useToasterStore()

	const isShowingCluster = useAtomValue(isShowingClustersAtom)
	const isFimstripExpanded = useAtomValue(filmstripExpandedAtom)
	const photosView = useAtomValue(photosViewAtom)
	const isPhotoFullscreen = useAtomValue(isPhotoFullscreenAtom)
	const isShowingFilmstrip = !isPhotoFullscreen && photosView !== "grid" && isFimstripExpanded

	const TOAST_LIMIT = 1

	useEffect(() => {
		toasts
			.filter((t) => t.visible) // Only consider visible toasts
			.filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit?
			.forEach((t) => toast.remove(t.id)) // Dismiss – Use toast.remove(t.id) for no exit animation
	}, [toasts])

	return (
		<Toaster
			position={"bottom-center"}
			reverseOrder={false}
			gutter={8}
			containerStyle={{ bottom: isShowingFilmstrip ? (isShowingCluster ? 280 : 200) : 60 }}
			toastOptions={{
				duration: 1000,
				className: "py-2 px-3 rounded-md",
				style: {
					backgroundColor:
						"#404040" /* bg-base-700 somehow toaster can't pass this to classname*/,
					color: "white",
					fontSize: "13px",
					animation: "none",
				},
			}}
		/>
	)
}
